import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { alertActions } from '../_services/essentials/store';
import Snackbar from '@mui/material/Snackbar';
import { Alert } from "@mui/material";

export { AppAlertBox };

function AppAlertBox() {
    const dispatch = useDispatch();
    const location = useLocation();
    const alert = useSelector(x => x.alert.value);

    useEffect(() => {
        dispatch(alertActions.clear());
    }, [location, dispatch]);

    const handleClose = (event) => {
        dispatch(alertActions.clear())
    };

    if (!alert) return null;
    return (
        // <Snackbar
        //     sx={{ width: '100%' }}
        //     anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        //     open={alert ? true : false}
        //     autoHideDuration={5000}
        //     onClose={handleClose}
        //     message={alert.message}
        // />
        <Snackbar
            open={alert ? true : false}
            autoHideDuration={5000}
            onClose={handleClose}
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            sx={{
                width: '34%', transform: (alert ? true : false) ? 'translateX(0)' : 'translateX(100%)',
                transition: 'transform .4s ease-out',
            }}
        >

            < Alert sx={{ width: '100%', borderRadius: '5px' }} severity={alert.type} >{alert.message} </Alert>

        </Snackbar>
    );
} 
